import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ups': {
    width: 375,
    height: 512,
    paths: [
      {
        d: 'M99.2 302.6C94 306.2 66.6 315.7 66.6 283.6V179.6H33.9V282.2C33.9 357.1 114.1 333.3 131.8 321.2V179.6H99.2V302.6zM0 74.4V295.3C0 399 74.9 430.5 187.7 479.4 300.1 430.5 375.4 399.2 375.4 295.3V74.4C259.1 12.8 93.6 24.8 0 74.4zM358.1 295.3C358.1 381.9 304.9 408.9 187.7 460.6 70.2 408.8 17.2 381.9 17.2 295.3V168.9C119.5 75.1 248.8 68.9 358.1 79.1V295.3zM148.5 187.9V400.7H181.2V332C205.6 339.3 252.9 329.4 252.9 253.5 252.9 156.1 172.2 172.6 148.5 187.9zM181.2 305.2V204.9C189.6 200.7 219.6 192.2 219.6 254.2 219.6 322.1 183.2 306 181.2 305.2zM260.3 218.8C260.4 266.1 311.9 261.3 312.5 289.2 313.1 312.7 282.1 312.2 261.7 294.1V324.2C297.9 345.7 343.6 332.3 344.9 290.7 346.6 239.2 290.8 244.1 291.5 217.5 292.1 197.2 322.1 197 340 215.3V186.9C311.5 164.9 260.1 177.7 260.3 218.8z'
      }
    ]
  }
})
